var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tag",style:({ 'background-color': _vm.tagColor, color: _vm.tagTextColor }),attrs:{"data-test-id":"Tag"},on:{"click":function($event){return _vm.onClick(_vm.tag)}}},[_c('span',[_vm._v(_vm._s(_vm.tag.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }